import { types } from 'mobx-state-tree';

import { dayOfWeekFullForm } from 'config/calendar';

export const BusinessHour = types.model({
  id: types.identifierNumber,
  establishment_id: types.number,
  day_of_week: types.enumeration('day_of_week', Object.values(dayOfWeekFullForm)),
  open_time: types.maybeNull(types.string),
  close_time: types.maybeNull(types.string),
  is_closed: types.maybeNull(types.boolean),
  is_day_week_begins: types.maybeNull(types.boolean),
  created_at: types.maybeNull(types.string),
  updated_at: types.maybeNull(types.string),
});
